import type React from "react";
import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Typography, Container, Paper, Box } from "@mui/material";
import EmployeeOnboardingView from "../../../components/Onboarding2/EmployeeOnboardingView";
import HROnboardingView from "../../../components/Onboarding2/HROnboardingView";
// import HROnboardingView from "../../components/Onboarding2/HROnboardingView"
import { getUser, getUserData } from "../../../common/utils";
import styles from "./OnboardingPage2.module.css";
import { IonContent, IonPage } from "@ionic/react";

const OnboardingPage: React.FC = () => {
  const { employeeId } = useParams<{ employeeId?: string }>();
  const history = useHistory();
  const [userRole, setUserRole] = useState<string>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const user = getUser();
      console.log("User data:", user);
      setUserRole(user.userData.role || "employee");
    } catch (error) {
      console.error("Error getting user data:", error);
      history.push("/login");
    } finally {
      setLoading(false);
    }
  }, [history]);

  if (loading) {
    return (
      <Container maxWidth="lg" className={styles.container}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="400px"
        >
          <Typography>Loading...</Typography>
        </Box>
      </Container>
    );
  }

  // const isHRView = userRole === "hr" || userRole === "admin"
  const isHRView = false; // Temporarily disable HR view for testing
  const targetEmployeeId = employeeId || getUser().userData.user_id;
  console.log("Target employee ID:", targetEmployeeId);
  return (
    <IonPage>
      <IonContent>
        <Container maxWidth="xl" className={styles.container}>
          <Paper elevation={2} className={styles.paper}>
            <Box className={styles.header}>
              <Typography variant="h4" component="h1" className={styles.title}>
                Employee Onboarding
              </Typography>
              <Typography
                variant="subtitle1"
                color="textSecondary"
                className={styles.subtitle}
              >
                {isHRView
                  ? "Manage employee onboarding process"
                  : "Complete your onboarding requirements"}
              </Typography>
            </Box>

            {isHRView ? (
              <HROnboardingView />
            ) : (
              <EmployeeOnboardingView employeeId={targetEmployeeId} />
            )}
          </Paper>
        </Container>
      </IonContent>
    </IonPage>
  );
};

export default OnboardingPage;
